module.exports = __webpack_public_path__ + "img/2_5.ec2c7d76.png";